import styled from "styled-components";
import { media } from '../../theme/breakpoints';

export const Header = styled.div`
    width: 100%;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    > .title-row {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 12px;

      h2 {
        margin: 0;
        flex: 1;
      }

      button {
        width: 100%;
      }
    }

    ${media.sm} {
      > .title-row {
        flex-direction: row;
        align-items: center;

        button {
          width: auto;
          margin-left: auto;
        }
      }
    }
`;
